<template>
  <div class="auth">
    <div class="auth-container">
      <h2>{{ isLogin ? 'Login' : 'Register' }}</h2>
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <input
            v-model="form.email"
            type="email"
            placeholder="Email"
            required
          >
        </div>
        <div class="form-group">
          <input
            v-model="form.password"
            type="password"
            placeholder="Password"
            required
          >
        </div>
        <button type="submit" class="btn" :disabled="loading">
          {{ loading ? 'Processing...' : (isLogin ? 'Login' : 'Register') }}
        </button>
      </form>
      <p class="toggle-text">
        {{ isLogin ? "Don't have an account?" : 'Already have an account?' }}
        <a href="#" @click.prevent="toggleMode">{{ isLogin ? 'Register' : 'Login' }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  name: 'AuthView',
  setup() {
    const store = useStore()
    const router = useRouter()
    const isLogin = ref(true)
    const error = ref('')
    const loading = ref(false)
    const form = ref({
      email: '',
      password: ''
    })

const handleSubmit = async () => {
      error.value = ''
      loading.value = true
      
      try {
        if (isLogin.value) {
          console.log('Sending login request:', {
            email: form.value.email,
            password: '[REDACTED]'
          })
          const response = await store.dispatch('auth/login', form.value)
          console.log('Login successful:', response)
          
          // Redirect to the intended route or home
          const redirectPath = router.currentRoute.value.query.redirect || '/'
          router.push(redirectPath)
        } else {
          console.log('Sending register request:', {
            email: form.value.email,
            password: '[REDACTED]'
          })
          const response = await store.dispatch('auth/register', form.value)
          console.log('Registration successful:', response)
          error.value = 'Registration successful! Please login.'
          isLogin.value = true
          form.value.password = ''
        }
      } catch (err) {
        console.error('Auth error:', err.response?.data || err.message)
        if (err.response?.status === 401) {
          error.value = 'Invalid email or password'
        } else if (err.response?.status === 409) {
          error.value = 'Email already exists'
        } else {
          error.value = err.response?.data?.message || err.response?.data?.error || 'Authentication failed'
        }
      } finally {
        loading.value = false
      }
    }

    const toggleMode = () => {
      isLogin.value = !isLogin.value
    }

return {
      isLogin,
      form,
      error,
      loading,
      handleSubmit,
      toggleMode
    }
  }
}
</script>

<style scoped>
.error-message {
  background-color: #ff5252;
  color: white;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 15px;
}
.auth {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

.auth-container {
  width: 100%;
  max-width: 400px;
  padding: 20px;
  background-color: #f8f9fa;
  border-radius: 8px;
}

.form-group {
  margin-bottom: 15px;
}

input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.btn {
  width: 100%;
  padding: 10px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn:hover:not(:disabled) {
  background-color: #369870;
}

.toggle-text {
  margin-top: 15px;
  text-align: center;
}

a {
  color: #42b983;
  text-decoration: none;
}
</style>

